export default __webpack_public_path__ + "382f6962142e2e8d0e646a04f11d4d1a.png";